'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useRaiseCollectorEvent } from '@/modules/collector/hooks/use-raise-collector-event';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { getIsUserPlatformDesktop } from '@/shared/modules/user-agent';
import { ThankYouDesktop } from '../thank-tou-desktop';
import { ThankYouMobile } from '../thank-you-mobile';
import * as Styled from './thank-you.styled';

/**
 * @useClient
 */
export const ThankYou = React.memo(function ThankYou() {
  const {
    images
  } = useEdgeConfigWidget(WidgetId.ThankYouContent);
  const {
    raiseCollectorEvent
  } = useRaiseCollectorEvent();
  React.useEffect(() => {
    raiseCollectorEvent({
      eventName: 'click',
      eventAction: '[Click]',
      eventCategory: '[Portal]',
      eventLabel: '[PortalPageLoaded]'
    });
  }, [raiseCollectorEvent]);
  const [isDesktopDevice, setIsDesktopDevice] = React.useState<boolean | undefined>(undefined);
  React.useEffect(() => {
    setIsDesktopDevice(getIsUserPlatformDesktop());
  }, []);
  if (isDesktopDevice === undefined) {
    return <Styled.Empty $background={images.background.src} />;
  }
  return isDesktopDevice === false ? <ThankYouMobile /> : <ThankYouDesktop />;
});